import { NgModule } from '@angular/core';
import { BrowserModule, Title, Meta } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { ReCaptchaModule } from 'angular-recaptcha3';
import constantURL from 'src/app/shared/constantURL';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    RouterModule,
    MatDialogModule,
    ReCaptchaModule.forRoot({
      invisible: {
        sitekey: constantURL.RECAPTCHA_KEY,
      },
      normal: {
        sitekey: constantURL.RECAPTCHA_KEY,
      },
      language: 'en',
    }),
  ],
  providers: [
    Title,
    Meta,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
